export default __webpack_public_path__ + "static/media/document-right-icon.176893e2.svg";